import { Component } from '@angular/core';

@Component({
  selector: 'pxl-layout',
  standalone: false,
  template: `
    <div class="layout-container">
      <header>
        <pxl-header></pxl-header>
      </header>

      <main>
        <router-outlet></router-outlet>
      </main>
    </div>
  `,
  styles: [
    `
      .layout-container {
        display: flex;
        flex-direction: column;
      }
      header {
        /* Header styling */
      }
      main {
        /* Main content styling */
      }
    `,
  ],
})
export class LayoutComponent {}
